var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreferencessmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.44 3.19a1.7 1.7 0 0 1-1.72 1.69A1.7 1.7 0 0 1 1 3.18c0-.92.77-1.68 1.72-1.68s1.72.76 1.72 1.69Zm5.8-.74c.42 0 .76.33.76.74 0 .4-.34.74-.75.74h-3.3a.75.75 0 0 1-.74-.74c0-.4.33-.74.75-.74h3.29ZM1.76 7.98h3.3c.4 0 .75.33.75.74 0 .4-.34.74-.76.74H1.75A.75.75 0 0 1 1 8.72c0-.4.34-.74.75-.74Zm7.53 2.4A1.7 1.7 0 0 0 11 8.7a1.7 1.7 0 0 0-1.72-1.69A1.7 1.7 0 0 0 7.56 8.7c0 .93.77 1.69 1.72 1.69Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferencessmall);
export default __webpack_public_path__ + "static/media/preferences.small.9b0eeb997ab0393d25c03120a14e03cb.svg";
export { ForwardRef as ReactComponent };